import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import logo from '../assets/logo.png';
import backgroundImage from '../assets/background.png';  // your transparent PNG
import mobileBackgroundImage from '../assets/mobileBackground.png';

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-gradient-to-b from-pink-100 to-pink-50 overflow-hidden">

        {/* Background Blobs */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-pink-300 rounded-full filter blur-3xl opacity-30 z-0 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-purple-300 rounded-full filter blur-2xl opacity-40 z-0 animate-pulse"></div>

        {/* Background Image - Desktop only */}
        <img
          src={backgroundImage}
          alt="Background"
          className="hidden md:block absolute top-20 left-0 w-full max-w-full h-[80vh] object-contain z-0 transform scale-105 transition-transform duration-300"
          style={{ pointerEvents: 'none' }}
        />

        {/* Logo */}
        <motion.img
          src={logo}
          alt="Simply Sigma Logo"
          className="w-[32rem] h-[32rem] object-contain z-10 mb-6"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
        />

        {/* Tagline */}
        <motion.h1
          className="text-5xl font-extrabold text-gray-800 z-10"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Simply Sigma
        </motion.h1>
        <motion.p
          className="text-xl mt-2 text-gray-600 z-10"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          Empowering Learning through Technology
        </motion.p>

        {/* Scroll Down Arrow */}
        <motion.div
          className="absolute bottom-10 z-10"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ChevronDown size={40} className="text-gray-500" />
        </motion.div>
      </section>

      {/* Second Section */}
      <section className="relative flex flex-col min-h-screen bg-gradient-to-b from-pink-50 to-white pt-20">

        {/* Top Menu Bar */}
        <div className="w-full fixed top-0 left-0 bg-gradient-to-r from-pink-100 to-pink-50 shadow z-50 px-8 py-4 flex justify-between items-center">
          <img src={logo} alt="Mini Logo" className="h-10 w-auto" />
          <nav className="flex space-x-6 text-gray-800 font-medium">
            <a href="#home" className="hover:text-pink-600 transition">Home</a>
            <a href="#about" className="hover:text-pink-600 transition">About</a>
            <a href="/services" className="hover:text-pink-600 transition">Services</a>
            <a href="https://forms.gle/dAbSkxLQuQhuhVur5" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600 transition">Contact</a>
          </nav>
        </div>

        {/* Main Content */}
        <div id="about" className="flex-grow pt-16 flex flex-col items-center text-center px-6">

          <h2 className="text-4xl font-bold text-gray-800 mb-6 z-10">Who We Are</h2>

          {/* Background Image for Mobile */}
          {/* Background Image - Mobile Only */}
<img
  src={mobileBackgroundImage}
  alt="Mobile Background"
  className="block md:hidden absolute top-0 left-0 w-full h-full object-cover opacity-20 z-0"
/>


          <div className="text-lg text-gray-600 max-w-3xl mb-10 z-10 space-y-4">
            <p className="font-bold text-[#800000]">
              Simply Sigma is an AI-powered education platform offering notes, test series, and intelligent question generation tailored to students' learning needs.
            </p>
            <p>
              At Simply Sigma Learning, we are dedicated to nurturing well-rounded learners through a unique blend of academic excellence and skill-based development. Here's what we offer:
            </p>

            <ul className="list-none space-y-3 text-left">
              <li>
                📚 <span className="font-semibold">Mathematics & Science Courses:</span> Structured curriculum for Grades 3–11 with conceptual clarity, interactive learning, and expert guidance.
              </li>
              <li>
                🤖 <span className="font-semibold">AI-Based Personalized Learning:</span> Our smart platform analyzes student performance and auto-generates custom tests and assignments to strengthen weak areas.
              </li>
              <li>
                🎭 <span className="font-semibold">Public Speaking & Personality Development:</span> Confidence-building modules with theatre games, debate sessions, group discussions, and MUN simulations to shape future leaders.
              </li>
              <li>
                💻 <span className="font-semibold">Tech Support & Solutions:</span> We provide customized IT services—from web development and digital marketing to AI chatbot integration—tailored to your business or educational needs.
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Strip */}
       {/* CTA Strip */}
<div
  className="w-full flex flex-col md:flex-row justify-center md:justify-between items-center px-6 py-4 bg-cream rounded-t-3xl text-black z-10 relative"
  style={{ backgroundColor: '#F4C2C2' }}
>
 
  {/* Desktop Text */}
  <h3 className="hidden md:block text-lg font-semibold max-w-[70%]">
    Your journey deserves a personalized path — book your free counselling and get a specially curated course today!
  </h3>

  {/* Button */}
  <a
    href="https://forms.gle/dAbSkxLQuQhuhVur5"
    target="_blank"
    rel="noopener noreferrer"
    className="z-50 block mt-2 md:mt-0 px-6 py-3 bg-pink-400 text-black font-semibold rounded-full hover:bg-pink-500 transition text-base md:text-lg w-full text-center md:w-auto"
  >
    Schedule Free Counselling &rarr;
  </a>
</div>

      </section>
      {/* Footer */}
<footer className="w-full text-center py-4 bg-pink-100 text-gray-700 text-sm">
  Website designed by <span className="font-semibold">Simply Sigma Learning Services</span>
</footer>

    </div>
  );
};

export default Home;
